import script from "./BaseImageElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseImageElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseImageElement.vue?vue&type=style&index=0&id=24fef706&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24fef706"]])

export default __exports__